import React, { useMemo, useRef, useState } from 'react';
import { useOutsideClick } from 'customHooks/useOutsideClick';
import { FileList } from 'components/common/types';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import FrameListPanel from 'components/pages/AvailabilityReport/AddFilter/FrameListPanel/FrameListPanel';
import { FilterFrameListProps } from './FilterFrameList.types';
import { calculateTotalFrameCount } from './FilterFrameList.utils';
import FrameListControlButton from './FrameListControlButton';
import { useSyncLocalStateWithProps, useUpdateParentOnChange } from './FilterFrameList.hooks';

const FilterFrameList: React.FC<FilterFrameListProps> = ({ selectedFrameList, changeFilters, isDisabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  const [selectedRouteFrameCodes, setSelectedRouteFrameCodes] = useState<RouteFrameCode[]>(
    selectedFrameList?.routeFrameCodes || [],
  );
  const [uploadedFrameLists, setUploadedFrameLists] = useState<FileList[]>(selectedFrameList?.uploadedFrameLists || []);

  useSyncLocalStateWithProps(
    selectedFrameList,
    setSelectedRouteFrameCodes,
    setUploadedFrameLists,
    selectedRouteFrameCodes,
    uploadedFrameLists,
  );

  useOutsideClick(dropdownRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  useUpdateParentOnChange(isOpen, selectedRouteFrameCodes, uploadedFrameLists, changeFilters);

  const totalCount = useMemo(() => calculateTotalFrameCount(selectedFrameList), [selectedFrameList]);

  const handleToggle = (): void => {
    if (!isDisabled) {
      setIsOpen(!isOpen);
    }
  };

  if (totalCount === 0) return null;

  return (
    <div ref={dropdownRef} className="relative inline-block">
      <FrameListControlButton isDisabled={isDisabled} isOpen={isOpen} totalCount={totalCount} onToggle={handleToggle} />

      {isOpen && (
        <div className="absolute z-50 mt-1 bg-transparent left-0 min-w-full">
          <FrameListPanel
            selectedRouteFrameCodes={selectedRouteFrameCodes}
            setSelectedRouteFrameCodes={setSelectedRouteFrameCodes}
            uploadedListOfFiles={uploadedFrameLists}
            setUploadedListOfFiles={setUploadedFrameLists}
          />
        </div>
      )}
    </div>
  );
};

export default FilterFrameList;
